<script></script>

<div class="mainWrraper">
<div class="imgWrraper">
    <img src="/images/loading2.gif" alt="loading" width="100%" height="100%">
</div>
</div>

<style>
    .mainWrraper{
        width: 100%;
        height: 100%;
        display: flex;
        overflow: hidden;
        align-items: center;
        justify-content: center;
        background-color: #0000005e;
        position: fixed;
        z-index: 7;
        top: 0;
    }
    .imgWrraper{
        width: 10vw;
        height: 10vw;
    }
</style>